/** @file tileKeyHandlers: the handler table for `tileBindings` over one Tile tab. */
import { tileDrafts } from './tileDrafts';
import { tilePaintUi } from './tilePaintUi';

/** The tab's draft key and the screen's operations: zoom (0 = fit), Save and close the tab. */
export type TileKeyContext = { draftKey: string; zoom: (dir: -1 | 0 | 1) => void; save: () => void; close: () => void };

/** One handler per `tileBindings` id. */
export function tileKeyHandlers(ctx: TileKeyContext): Record<string, () => void> {
  const ui = tilePaintUi.getState();
  const drafts = tileDrafts.getState();
  return {
    'tile.pencil': () => { ui.setTool('pencil'); },
    'tile.eraser': () => { ui.setTool('eraser'); },
    'tile.bucket': () => { ui.setTool('bucket'); },
    'tile.eyedropper': () => { ui.setTool('eyedropper'); },
    'tile.line': () => { ui.setTool('line'); },
    'tile.mirror': () => { ui.toggle('mirror'); },
    'tile.onion': () => { ui.toggle('onion'); },
    'tile.grid': () => { ui.toggle('grid'); },
    'tile.zoomFit': () => { ctx.zoom(0); },
    'tile.zoomIn': () => { ctx.zoom(1); },
    'tile.zoomOut': () => { ctx.zoom(-1); },
    'tile.undo': () => { drafts.undo(ctx.draftKey); },
    'tile.redo': () => { drafts.redo(ctx.draftKey); },
    'tile.redoAlt': () => { drafts.redo(ctx.draftKey); },
    'tile.save': ctx.save,
    'tile.close': ctx.close,
  };
}
